// Linked events constraint: for each declared linked pair (E_a, E_b) on the same day,
// and for each user U, enforce sum_R x_{U,E_a,R} - sum_R x_{U,E_b,R} = 0.
// This means U does both or neither.
// Requires: model.optimizationIndexes.linkedEdges, .users, .staffRequiredByRole, .decisionVariables
export function buildLinkedEventsConstraints(model, _params = {}) {
  const idx = model?.optimizationIndexes || {};
  const users = Object.keys(idx.users || {});
  const edges = Array.isArray(idx.linkedEdges) ? idx.linkedEdges : [];
  const staffRequiredByRole = idx.staffRequiredByRole || {};
  const declared = new Set(Object.keys(idx.decisionVariables || {}));

  if (!edges.length || !users.length) return [];

  const constraints = [];
  for (const edge of edges) {
    const a = edge?.a;
    const b = edge?.b;
    if (!a || !b) continue;
    const rolesA = Object.keys(staffRequiredByRole[a] || {});
    const rolesB = Object.keys(staffRequiredByRole[b] || {});
    for (const uKey of users) {
      const vars = [
        ...rolesA.map((r) => `x_${uKey}_${a}_${r}`),
        ...rolesB.map((r) => `x_${uKey}_${b}_${r}`),
      ].filter((name) => declared.has(name));
      if (!vars.length) continue;
      const coeffs = [
        ...rolesA.map(() => 1),
        ...rolesB.map(() => -1),
      ];
      // equality: sumA - sumB == 0
      constraints.push({ linear: { vars, coeffs }, domain: [0, 0] });
    }
  }

  return constraints;
}

